<router-outlet *ngIf="!isLoading"></router-outlet>
<ngx-ui-loader [text]="loaderText" [class]="'beautified-text'"></ngx-ui-loader>